import { render, staticRenderFns } from "./ForwardMessageDialogV2.vue?vue&type=template&id=ab68cefe&scoped=true&"
import script from "./ForwardMessageDialogV2.vue?vue&type=script&lang=js&"
export * from "./ForwardMessageDialogV2.vue?vue&type=script&lang=js&"
import style0 from "./ForwardMessageDialogV2.vue?vue&type=style&index=0&id=ab68cefe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab68cefe",
  null
  
)

export default component.exports